// Filtro Calentador de Agua — product section behavior
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var hlsScriptPromise = null;
  function ensureHls() {
    if (window.Hls) return Promise.resolve();
    if (hlsScriptPromise) return hlsScriptPromise;
    hlsScriptPromise = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.15/dist/hls.min.js';
      s.onload = resolve;
      s.onerror = resolve;
      document.head.appendChild(s);
    });
    return hlsScriptPromise;
  }

  function setupVideos(root) {
    var videos = root.querySelectorAll('[data-pfc-hls]');
    videos.forEach(function (video) {
      var src = video.getAttribute('data-pfc-hls');
      if (!src) return;
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = src;
      } else {
        ensureHls().then(function () {
          if (window.Hls && window.Hls.isSupported()) {
            var hls = new window.Hls();
            hls.loadSource(src);
            hls.attachMedia(video);
          }
        });
      }
    });
  }

  function setupCarousels(root) {
    root.querySelectorAll('[data-pfc-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-pfc-track]');
      var dotsWrap = carousel.querySelector('[data-pfc-dots]');
      if (!track || !dotsWrap) return;
      var cards = Array.prototype.slice.call(track.children);
      var dots = Array.prototype.slice.call(dotsWrap.children);
      if (!cards.length) return;
      var index = 0;
      var paused = false;
      var timer = null;
      var resumeTimeout = null;

      function setActiveDot(i) {
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }
      function goTo(i) {
        index = (i + cards.length) % cards.length;
        var card = cards[index];
        track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActiveDot(index);
      }
      function next() { goTo(index + 1); }
      function stop() { if (timer) clearInterval(timer); }
      function start() {
        stop();
        timer = setInterval(function () { if (!paused) next(); }, 4000);
      }
      function pause() {
        paused = true;
        if (resumeTimeout) clearTimeout(resumeTimeout);
      }
      function resumeLater() {
        if (resumeTimeout) clearTimeout(resumeTimeout);
        resumeTimeout = setTimeout(function () { paused = false; }, 2000);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { pause(); goTo(i); resumeLater(); });
      });
      ['pointerdown', 'touchstart'].forEach(function (evt) {
        track.addEventListener(evt, pause, { passive: true });
      });
      ['pointerup', 'touchend', 'mouseleave'].forEach(function (evt) {
        track.addEventListener(evt, resumeLater, { passive: true });
      });

      var scrollDebounce;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollDebounce);
        scrollDebounce = setTimeout(function () {
          var trackRect = track.getBoundingClientRect();
          var closest = 0, closestDist = Infinity;
          cards.forEach(function (c, i) {
            var dist = Math.abs(c.getBoundingClientRect().left - trackRect.left);
            if (dist < closestDist) { closestDist = dist; closest = i; }
          });
          index = closest;
          setActiveDot(index);
        }, 100);
      }, { passive: true });

      setActiveDot(0);
      start();
    });
  }

  ready(function () {
    setupVideos(document);
    setupCarousels(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    setupVideos(e.target);
    setupCarousels(e.target);
  });
})();
